import Preloader from './Preloader.jsx';

export default Preloader;
